module.exports = __webpack_public_path__ + "img/sicredi.2bd5be5a.svg";